// Models
import { FormFieldSchema } from 'app/shared/models/form';
import { U21FormFieldTypes } from 'app/shared/u21-ui/components';

// Utils
import { required } from 'app/shared/utils/validation';

// Constants
import { CONTACT_TYPE_OPTIONS } from 'app/modules/goAML/schemas/catalogues/contactType';
import { COUNTRY_CODE_OPTIONS } from 'app/modules/goAML/schemas/catalogues/countryCode';

export const ADDRESS_TYPE_FIELD: FormFieldSchema<string> = {
  label: 'Address type',
  name: 'address_type',
  required: true,
  type: U21FormFieldTypes.SELECT,
  fieldProps: {
    options: CONTACT_TYPE_OPTIONS,
  },
  validate: required('Address type is required.'),
};

export const ADDRESS_FIELD: FormFieldSchema<string> = {
  label: 'Address',
  name: 'address',
  required: true,
  type: U21FormFieldTypes.TEXT,
  validate: required('Address is required.'),
};

export const TOWN_FIELD: FormFieldSchema<string> = {
  label: 'Town',
  name: 'town',
  type: U21FormFieldTypes.TEXT,
};

export const CITY_FIELD: FormFieldSchema<string> = {
  label: 'City',
  name: 'city',
  required: true,
  type: U21FormFieldTypes.TEXT,
  validate: required('City is required.'),
};

export const ZIP_FIELD: FormFieldSchema<string> = {
  label: 'ZIP code',
  name: 'zip',
  type: U21FormFieldTypes.TEXT,
};

export const COUNTRY_FIELD: FormFieldSchema<string> = {
  label: 'Country',
  name: 'country_code',
  type: U21FormFieldTypes.SELECT,
  fieldProps: {
    options: COUNTRY_CODE_OPTIONS,
  },
};

export const STATE_FIELD: FormFieldSchema<string> = {
  label: 'State',
  name: 'state',
  type: U21FormFieldTypes.TEXT,
};

export const COMMENTS_DATE: FormFieldSchema<string> = {
  label: 'Comments',
  name: 'comments',
  type: U21FormFieldTypes.TEXTAREA,
};

export const T_ADDRESS_SCHEMA = [
  ADDRESS_TYPE_FIELD,
  ADDRESS_FIELD,
  COUNTRY_FIELD,
  STATE_FIELD,
  TOWN_FIELD,
  CITY_FIELD,
  ZIP_FIELD,
  COMMENTS_DATE,
];
